function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.5 5.83325H17.5",
    stroke: "#0B3775",
    style: {
      stroke: "#0B3775",
      stroke: "color(display-p3 0.0431 0.2157 0.4588)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 10H17.5",
    stroke: "#0B3775",
    style: {
      stroke: "#0B3775",
      stroke: "color(display-p3 0.0431 0.2157 0.4588)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 14.1667H17.5",
    stroke: "#0B3775",
    style: {
      stroke: "#0B3775",
      stroke: "color(display-p3 0.0431 0.2157 0.4588)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.d7d2b4373d6db3a57d6d557ae542cd1b.svg";
export { ForwardRef as ReactComponent };